import React from "react";
import calendlyStyle from "./calendlyStyle";
import _get from "lodash/get";
import _includes from "lodash/includes";
import ContentBox from "../Box/ContentBox/ContentBox";
import callIcon from "../../assets/icons/generic/IconCallClock";
import { Button, Divider, Link as MuiLink } from "@mui/material";
import { Customer } from "../../types/Entities/Customer";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import { getCaseLink } from "../../services/productService";
import { customerHasConsent, getCustomerConsent } from "../../services/customerService";
import dayjs from "dayjs";
import { Link } from "react-router";

type CalendlyAppointmentProps = {
  product: AbstractCase;
  customer: Customer;
  type: "advisoryAppointment" | "lawyerCounselingCall" | "callbackAppointment";
};

const CalendlyAppointment = ({ product, customer, type }: CalendlyAppointmentProps) => {
  const calendlyData = _get(product, type);

  if (!_get(calendlyData, "appointment") || !customer || _includes(["processed", "not_processed"], _get(calendlyData, "status"))) {
    return null;
  }

  const getConsentUrl = () => {
    return getCaseLink(product) + "/zustimmung_gespraechsaufzeichnung";
  };

  return (
    <ContentBox headline={"Mein Beratungstermin"} icon={callIcon}>
      <div>
        Sie haben einen Termin für den {dayjs(calendlyData.appointment.date).format("DD.MM.YYYY")} um {dayjs(calendlyData.appointment.date).format("HH:mm")} Uhr
        gebucht und werden unter der Nummer {customer.telephone} angerufen.
      </div>
      <Button component={MuiLink} href={calendlyData.rescheduleUrl} target="_blank" sx={calendlyStyle.appointmentBoxbutton} color={"primary"} fullWidth>
        Termin verschieben
      </Button>
      <Button component={MuiLink} href={calendlyData.cancelUrl} target="_blank" sx={calendlyStyle.appointmentBoxbutton} color={"primary"} fullWidth>
        Termin absagen
      </Button>
      <Button component={Link} to={"/servicewelt/mein-konto#personalData"} sx={calendlyStyle.appointmentBoxbutton} color={"primary"} fullWidth>
        Telefonnummer ändern
      </Button>
      {calendlyData["phoneCallEnabled"] === true && (
        <>
          <Divider />
          <Typography variant={"h5"} component={"h3"} sx={{ textAlign: "center" }}>
            Persönliche Zusammenfassung
          </Typography>
          {!getCustomerConsent(customer, "callRecordingAndSummary") && (
            <Typography>Wünschen Sie eine Zusammenfassung Ihres Beratungsgesprächs? Dann geben Sie uns hier Ihre Einverständniserklärung ab.</Typography>
          )}
          {getCustomerConsent(customer, "callRecordingAndSummary") && customerHasConsent(customer, "callRecordingAndSummary") && (
            <Typography>
              Sie erhalten eine automatische Zusammenfassung dieses Gesprächs und haben hierzu dem Mitschnitt von Beratungsgesprächen zugestimmt. Hier können
              Sie Ihr Einverständnis jederzeit widerrufen:
            </Typography>
          )}
          {getCustomerConsent(customer, "callRecordingAndSummary") && !customerHasConsent(customer, "callRecordingAndSummary") && (
            <Typography>
              Sie erhalten <strong>keine</strong> automatische Zusammenfassung dieses Gesprächs, weil Sie dem Mitschnitt von Beratungsgesprächen widersprochen
              haben. Hier können Sie Ihr Einverständnis jederzeit erteilen:
            </Typography>
          )}
          <Button component={MuiLink} href={getConsentUrl()} sx={calendlyStyle.appointmentBoxbutton} color={"primary"} fullWidth>
            Einverständnis verwalten
          </Button>
        </>
      )}
    </ContentBox>
  );
};

export default CalendlyAppointment;
